import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-order-medicine-list',
    templateUrl: './order-medicine-list.component.html',
    styleUrls: ['./order-medicine-list.component.scss'],
    standalone: false
})
export class OrderMedicineListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
